// extracted by mini-css-extract-plugin
export var divider = "_3c-0";
export var dividerText = "_3c-1";